import { Avatar } from "../components/Avatar";
import { CitationGrid } from "../components/Citation";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import React from "react";
const wrapperVariants = cva("s-flex s-flex-col s-@container @xs:s-flex-row", {
    variants: {
        messageType: {
            agent: "s-pr-0",
            me: "s-pl-9",
            user: "s-pr-9",
        },
    },
    defaultVariants: {
        messageType: "agent",
    },
});
const messageVariants = cva("s-flex s-rounded-2xl s-max-w-full", {
    variants: {
        type: {
            user: "s-gap-2 s-w-fit",
            agent: "s-w-full s-gap-3 s-flex-col",
        },
    },
    defaultVariants: {
        type: "agent",
    },
});
// This component should only contain padding (inside the bubble).
// Any margin (inter-message spacing) should live outside of Sparkle.
export const ConversationMessageContainer = React.forwardRef(({ children, className, messageType, type, ...props }, ref) => {
    return (React.createElement("div", { ref: ref, className: cn(wrapperVariants({ messageType })) },
        React.createElement("div", { className: cn(messageVariants({ type, className })), ...props }, children)));
});
ConversationMessageContainer.displayName = "ConversationMessageContainer";
export const ConversationMessageContent = React.forwardRef(({ children, citations, className, type, reversed, showContent = true, ...props }, ref) => {
    return (React.createElement(React.Fragment, null,
        type === "user" && citations && citations.length > 0 && (React.createElement(CitationGrid, { reversed: reversed }, citations)),
        showContent && (React.createElement("div", { ref: ref, className: cn("s-flex s-min-w-0 s-flex-col s-gap-1", type === "user" &&
                "s-rounded-2xl s-bg-muted-background dark:s-bg-muted-background-night s-px-4 s-py-3", className), ...props },
            React.createElement("div", { className: "s-text-base s-text-foreground dark:s-text-foreground-night" }, children),
            type === "agent" && citations && citations.length > 0 && (React.createElement(CitationGrid, null, citations))))));
});
ConversationMessageContent.displayName = "ConversationMessageContent";
export const ConversationMessageAvatar = React.forwardRef(({ avatarUrl, isBusy, isDisabled, name = "", className, type, ...props }, ref) => {
    return (React.createElement("div", { ref: ref, className: cn("conversation:s-p-0 s-flex s-gap-2", className), ...props },
        React.createElement(Avatar, { name: name, visual: avatarUrl, busy: isBusy, disabled: isDisabled, isRounded: type === "user", size: "xs" })));
});
ConversationMessageAvatar.displayName = "ConversationMessageAvatar";
export const ConversationMessageTitle = React.forwardRef(({ name = "", timestamp, infoChip, completionStatus, renderName, className, ...props }, ref) => {
    return (React.createElement("div", { ref: ref, className: cn("s-inline-flex s-flex-1 s-items-center s-justify-between s-gap-0.5", className), ...props },
        React.createElement("div", { className: "s-inline-flex s-items-baseline s-gap-2 s-text-foreground dark:s-text-foreground-night" },
            React.createElement("span", { className: "s-text-sm s-font-medium" }, renderName(name)),
            React.createElement("span", { className: "s-text-xs s-text-muted-foreground dark:s-text-muted-foreground-night" }, timestamp),
            infoChip && (React.createElement("div", { className: "s-inline-flex s-self-[anchor-center]" }, infoChip))),
        React.createElement("div", { className: "s-ml-1 s-inline-flex s-items-center" }, completionStatus !== null && completionStatus !== void 0 ? completionStatus : null)));
});
ConversationMessageTitle.displayName = "ConversationMessageTitle";
//# sourceMappingURL=ConversationMessages.js.map